import { useState } from 'react';
import { criarFeedback } from '../../../../api/autenticacao';

export default function useFeedbackModal() {
  const [descricao, setDescricao] = useState('');
  const [aceitaEntrarEmContato, setAceitaEntrarEmContato] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(false);

  const handleSubmit = () => {
    if (loading) return;
    setLoading(true);
    const allowContactFormatado = aceitaEntrarEmContato ? 'S' : 'N';
    criarFeedback({ descricao, aceitaEntrarEmContato: allowContactFormatado })
      .then(response => {
        if (response.data.status === 'success') {
          setSubmitted(true);
        } else {
          setErro(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setErro(true);
      });
  };

  return {
    loading,
    submitted,
    erro,
    handleSubmit,
    setDescricao,
    setAceitaEntrarEmContato,
    setSubmitted,
    descricao,
    aceitaEntrarEmContato,
    setErro
  };
}
